export default __webpack_public_path__ + "static/ActiveGlobal-2ae633ee0a78e761682c99ab1d0efca3.jpg";